import { useEffect } from "react";
import { Configuracao as Configuracoes } from "src/components/contas/ConfiguracaoRevenda";
import { appStore } from "src/framework/store/AppStore";


const PAGE_TITLE = "Configurações"
const ConfiguracaoRevenda = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE)
    return () => {
      appStore.setPageTitle("")
    }
  }, [])
  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <Configuracoes />
        </div>
      </div>
    </div>
  );
};

export { ConfiguracaoRevenda };